var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouletteWinnerBorderTsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.58 229.51",
    style: {
      enableBackground: "new 0 0 456.58 229.51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFE94D;}\n\t.st2{fill:#FFC3E0;}\n\t.st3{fill:#E72E5C;}\n\t.st4{fill:#FFDA3E;}\n\t.st5{fill:#1DB3DB;}\n\t.st6{fill:#E0D5B3;}\n\t.st7{fill:#871233;}\n\t.st8{fill:#FFEA6C;}\n\t.st9{fill:#EFE8CE;}\n\t.st10{fill:#FFED10;}\n\t.st11{fill:none;stroke:#E72E5C;stroke-width:8;stroke-miterlimit:10;}\n\t.st12{fill:#FFB8D3;}\n\t.st13{fill:none;stroke:#E0D5B3;stroke-width:6;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#E72E5C;stroke-width:5;stroke-miterlimit:10;}\n\t.st15{clip-path:url(#SVGID_00000010283456636350333160000005735102433520420994_);}\n\t.st16{fill:#A1E7FF;}\n\t.st17{fill:#131E60;}\n\t.st18{fill:#5B92F4;}\n\t.st19{fill:#D2E8FF;}\n\t.st20{fill:#0A1956;}\n\t.st21{fill:none;stroke:#5B92F4;stroke-width:8;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#5B92F4;stroke-width:5;stroke-miterlimit:10;}\n\t.st23{clip-path:url(#SVGID_00000060731348865265368750000017853372503251115437_);}\n\t.st24{fill:#D9A4FF;}\n\t.st25{fill:#7622B2;}\n\t.st26{fill:#2D094C;}\n\t.st27{fill:none;stroke:#7622B2;stroke-width:8;stroke-miterlimit:10;}\n\t.st28{fill:none;stroke:#7622B2;stroke-width:5;stroke-miterlimit:10;}\n\t.st29{clip-path:url(#SVGID_00000158718889427342532750000007678738616440772237_);}\n\t.st30{fill:#57008C;}\n\t.st31{fill:#C63E74;}\n\t.st32{fill:#968D35;}\n\t.st33{fill:#C95D96;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M440.88,3.44H15.04c-4.26,0-7.72,3.46-7.72,7.72v206.23c0,4.26,3.46,7.72,7.72,7.72h425.85 c4.26,0,7.72-3.46,7.72-7.72V11.16C448.6,6.9,445.15,3.44,440.88,3.44z M418.39,188.41c0,1.42-1.15,2.58-2.58,2.58H43.83 c-1.42,0-2.58-1.15-2.58-2.58V38.95c0-1.42,1.15-2.58,2.58-2.58h371.98c1.42,0,2.58,1.15,2.58,2.58V188.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M443.69,225.51H12.89c-4.91,0-8.89-3.98-8.89-8.89V12.89C4,7.98,7.98,4,12.89,4h430.8 c4.91,0,8.89,3.98,8.89,8.89v203.72C452.58,221.52,448.6,225.51,443.69,225.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M415.82,191.57H43.83c-1.42,0-2.58-1.15-2.58-2.58V39.78c0-1.42,1.15-2.58,2.58-2.58h371.98 c1.42,0,2.58,1.15,2.58,2.58V189C418.39,190.42,417.24,191.57,415.82,191.57z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 85.37,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 154.92,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 225.11,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 294.84,
    cy: 20.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 365.11,
    cy: 20.58,
    r: 8.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 23.51,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 152.36,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 79.6,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 85.37,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 154.92,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 225.11,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 294.84,
    cy: 208.92,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 365.11,
    cy: 208.92,
    r: 8.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 23.84,
    cy: 207.37,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 22.57,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 152.36,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 79.6,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 435.66,
    cy: 208.02,
    r: 8.07
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouletteWinnerBorderTsl);
export default __webpack_public_path__ + "static/media/roulette-winner-border-tsl.10811a1fc44f25804728651794ef205a.svg";
export { ForwardRef as ReactComponent };